import ApplicationController from "./application_controller";

export default class extends ApplicationController {

    static targets = [
        "firstName", "lastName", "email", "accountingEmail", "phone",
        "companyStreet", "companyCity", "companyZip", "companyCountry",
        "billingStreet", "billingCity", "billingZip", "billingCountry",
        "pmSystem", "channelManager", "properties"
    ];

    connect() {
        this.element.addEventListener("submit", this.validateForm.bind(this));
        let step = this.element.dataset.step;
        this.loadFormData(step);

        // Initialize billing validation state on Step 2
        if (step === "2") {
            const checkbox = document.getElementById("different_billing");
            if (checkbox) {
                this.toggleBillingValidation({ target: checkbox });
            }
        }
    }

    toggleBillingValidation(event) {
        const isChecked = event.target.checked;
        const billingFields = this.element.querySelectorAll('[data-conditional-field="billing"]');

        billingFields.forEach(field => {
            if (isChecked) {
                // Enable validation for billing fields
                const fieldName = field.name.replace('billing_', '');
                if (fieldName === 'zip') {
                    field.dataset.validate = 'required,zip';
                } else {
                    field.dataset.validate = 'required';
                }
                field.dataset.touched = 'false'; // Reset touched state
            } else {
                // Disable validation for billing fields
                field.dataset.validate = '';
                field.dataset.touched = 'false';

                // Clear any existing errors
                if (this.element['form-validation']) {
                    this.element['form-validation'].clearError(field);
                }
            }
        });
    }

    validateForm(event) {
        event.preventDefault();
        let step = this.element.dataset.step;
        let isValid = true;

        switch (step) {
            case "1":
                // Step 1 validation handled by form-validation controller
                // Check if form-validation controller exists and run it
                if (this.element['form-validation']) {
                    isValid = this.element['form-validation'].validate();
                    if (!isValid) {
                        return; // Stop if validation fails
                    }
                }
                break;
            case "2":
                // Step 2 validation handled by form-validation controller
                if (this.element['form-validation']) {
                    isValid = this.element['form-validation'].validate();
                    if (!isValid) {
                        return; // Stop if validation fails
                    }
                }
                break;
            case "3":
                // Step 3 validation handled by form-validation controller
                if (this.element['form-validation']) {
                    isValid = this.element['form-validation'].validate();
                    if (!isValid) {
                        return; // Stop if validation fails
                    }
                }
                this.clearFormData();
                break;
            case "4":
                this.clearFormData();
                isValid = true;
                break;
            default:
                console.warn("Unknown step:", step);
                break;
        }

        if (isValid) {
            if (step !== "4") {
                this.saveFormData(step);
            }
            this.element.submit();
        }
    }

    // Local Storage
    saveFormData(step) {
        let formData = {};

        if (step === "1") {
            formData = {
                firstName: this.firstNameTarget.value.trim(),
                lastName: this.lastNameTarget.value.trim(),
                email: this.emailTarget.value.trim(),
                accountingEmail: this.accountingEmailTarget.value.trim(),
                phone: this.phoneTarget.value.trim(),
            };
        }

        if (step === "2") {
            formData = {
                companyStreet: this.companyStreetTarget.value.trim(),
                companyCity: this.companyCityTarget.value.trim(),
                companyZip: this.companyZipTarget.value.trim(),
                companyCountry: this.companyCountryTarget.value.trim(),
                billingStreet: this.billingStreetTarget.value.trim(),
                billingCity: this.billingCityTarget.value.trim(),
                billingZip: this.billingZipTarget.value.trim(),
                billingCountry: this.billingCountryTarget.value.trim(),
                differentBilling: document.getElementById("different_billing").checked,
            };
        }

        if (step === "3") {
            formData = {
                pmSystem: this.pmSystemTarget.value.trim(),
                channelManager: this.channelManagerTarget.value.trim(),
                properties: document.querySelector('input[name="properties"]:checked')?.value || "",
                source: document.querySelector('input[name="source"]:checked')?.value || "",
            };
        }

        localStorage.setItem(`pm_step_${step}`, JSON.stringify(formData));
    }

    //  Učitavanje podataka iz Local Storage
    loadFormData(step) {
        let storedData = localStorage.getItem(`pm_step_${step}`);
        if (storedData) {
            let formData = JSON.parse(storedData);

            if (step === "1") {
                this.firstNameTarget.value = formData.firstName || "";
                this.lastNameTarget.value = formData.lastName || "";
                this.emailTarget.value = formData.email || "";
                this.accountingEmailTarget.value = formData.accountingEmail || "";
                this.phoneTarget.value = formData.phone || "";
            }

            if (step === "2") {
                this.companyStreetTarget.value = formData.companyStreet || "";
                this.companyCityTarget.value = formData.companyCity || "";
                this.companyZipTarget.value = formData.companyZip || "";
                this.companyCountryTarget.value = formData.companyCountry || "";
                this.billingStreetTarget.value = formData.billingStreet || "";
                this.billingCityTarget.value = formData.billingCity || "";
                this.billingZipTarget.value = formData.billingZip || "";
                this.billingCountryTarget.value = formData.billingCountry || "";

                if (formData.differentBilling !== undefined) {
                    document.getElementById("different_billing").checked = formData.differentBilling;
                }
            }

            if (step === "3") {
                this.pmSystemTarget.value = formData.pmSystem || "";
                this.channelManagerTarget.value = formData.channelManager || "";

                if (formData.pmSystem) {
                    document.querySelector('[data-dropdown-pm-target="selectedText"]').textContent = formData.pmSystem;
                }
                if (formData.channelManager) {
                    document.querySelectorAll('[data-dropdown-pm-target="selectedText"]')[1].textContent = formData.channelManager;
                }

                let properties = formData.properties;
                if (properties) {
                    let radioInput = document.querySelector(`input[name="properties"][value="${properties}"]`);
                    if (radioInput) radioInput.checked = true;
                }
                if (formData.source) {
                    let radioInput = document.querySelector(`input[name="source"][value="${formData.source}"]`);
                    if (radioInput) radioInput.checked = true;
                }
            }
        }
    }

    //  Brisanje
    clearFormData() {
        localStorage.clear();
    }
}
